import { useState } from "react";
import SoftBox from "components/SoftBox";
import SlugTabs from "cxfcomponents/SlugTabs";
import { Overview } from "./overview";
import { Users } from "./users";
import { Integrations } from "./integrations";
import { Flows } from "./flows";
import { useSlugConnector } from "hooks/useSlugConnector";
import { Versions } from "./versions";

const tabsData = ["overview", "users", "integrations", "flows", "versions"];

export const FlowTabs = () => {
   const { connector, isReadOnlyAccess } = useSlugConnector(false);
   const [currentTab, setCurrentTab] = useState("overview");

   const renderTab = () => {
      switch (currentTab) {
         case "overview":
            return <Overview connector={connector} isReadOnlyAccess={isReadOnlyAccess} />;
         case "users":
            return <Users isReadOnlyAccess={isReadOnlyAccess} connector={connector} />;
         case "integrations":
            return <Integrations connector={connector} isReadOnlyAccess={isReadOnlyAccess} />;
         case "flows":
            return <Flows connector={connector} isReadOnlyAccess={isReadOnlyAccess} />;
         case "versions":
            return <Versions connector={connector} isReadOnlyAccess={isReadOnlyAccess} />;
      }

      return <></>;
   };

   if (!connector?.id) return <></>;

   return (
      <SoftBox>
         <SoftBox paddingBottom="24px">
            <SlugTabs tabs={tabsData} value={currentTab} onChange={setCurrentTab} />
            {renderTab()}
         </SoftBox>
      </SoftBox>
   );
};
